import { useMemo } from 'react';

import type { GroupBase } from 'react-select';
import type { CreatableProps } from 'react-select/creatable';
import Creatable from 'react-select/creatable';

import { LoadingIndicator } from './react-select';
import { ClearIndicator } from './react-select-clear-indicator';
import { componentsStyles } from './react-select-component-style';
import { newContainer } from './react-select-new-container';

export type RCreatableProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Omit<CreatableProps<Option, IsMulti, Group>, 'isDisabled'> & {
  label?: string;
  disabled?: boolean;
  menuClassName?: string;
};

export function CreatableSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ label, disabled, menuClassName, ...props }: RCreatableProps<Option, IsMulti, Group>) {
  const ControlComponent = useMemo(() => newContainer({ label }), [label]);
  const styleClasses = useMemo(
    () => componentsStyles(props.isMulti, disabled, menuClassName),
    [props.isMulti, disabled, menuClassName]
  );

  return (
    <Creatable
      {...props}
      isDisabled={disabled}
      components={{
        Control: ControlComponent,
        LoadingIndicator,

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ClearIndicator,
      }}
      classNames={styleClasses}
      menuShouldScrollIntoView={false}
      menuPlacement="auto"
      menuPortalTarget={
        typeof props.menuPortalTarget === 'undefined'
          ? document.getElementById('portal-root') || document.body
          : props.menuPortalTarget
      }
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      openMenuOnFocus
    />
  );
}
